export const defaultValue = {
  store_code: '',
  product_code: '',
  list_price: 0,
  sale_price: 0,
  togo_price: 0,
  employee_price: 0,
  member_price: 0,
  vip_price: 0,
  uber_eats_price: 0,
  food_panda_price_price: 0,
  go_foodie_price: 0,
  foodomo_price: 0,
  retail_price: 0,
}

export const searchDefValue = {
  store_code: '',
  product_code: '',
} 